// Translation for ro
export const ro = {
        common: {
            save: 'Salvează',
            cancel: 'Anulează',
            close: 'Închide',
            delete: 'Șterge',
            edit: 'Editează',
            activate: 'Activează',
            add: 'Adaugă',
            saving: 'Se salvează...',
            loading: 'Se încarcă...',
            active: 'ACTIV',
            inUse: 'În utilizare',
            test: 'Test',
            searchApps: 'Cauta aplicații...',
            betaBanner: 'BETA - Serviciul nu este disponibil încă!'
        },
        header: {
            creditBalance: 'Sold',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Conectează-te',
            signUp: 'Înregistrare',
            username: 'Nume de utilizator',
            password: 'Parolă',
            continue: 'Continuă',
            noAccount: 'Nu ai cont?',
            hasAccount: 'Ai deja cont?',
            loginError: 'Eroare de conectare',
            invalidCredentials: 'Nume de utilizator sau parolă nevalide',
            rateLimited: 'Prea multe încercări de conectare. Te rog astepta.',
            sessionExpired: 'Sesiunea ta a expirat. Te rog folosesc o nouă legătură magică.',
            magicLinkInvalid: 'Legătura de conectare este nevalidă sau a expirat.',
            magicLinkSuccess: 'Bun venit! Te-ai conectat cu succes.',
            magicLinkProcessing: 'Se procesează conectarea...',
            connectionError: 'Eroare de conexiune. Te rog incearca din nou.'
        },
        profile: {
            myProgress: 'Progresul Meu de Învățare',
            signOut: 'Deconectare',
            plan: 'Plan: '
        },
        settings: {
            title: 'Setări',
            tabs: {
                uiSettings: 'Setări UI',
                systemPrompt: 'Instrucțiune Sistem',
                llmProfiles: 'Profiluri LLM',
                ttsProfiles: 'Profiluri TTS',
                language: 'Limbă',
            },
            uiSettings: {
                title: 'Interfață Utilizator',
                themeMode: 'Mod Temă',
                darkMode: 'Mod Întunecat',
                lightMode: 'Mod Luminos',
                themeColor: 'Culoare Temă',
                themeColorDesc: 'Alege culoarea de accent pentru butoane, pictograme și evidențieri',
                background: 'Fundal',
                backgroundDesc: 'Alege un fundal pentru spațiul tău de lucru',
                selectBackgroundColor: 'Selectează Culoarea Fundalului',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focalizare',
                    concentration: 'Concentrare',
                    relaxation: 'Relaxare',
                    lianas: 'Liane',
                    color: 'Culoare'
                },
                backgroundColors: {
                    deepDark: 'Negru Profund',
                    darkGrey: 'Gri Închis',
                    midnightBlue: 'Albastru Miezul Nopții',
                    indigo: 'Indigo',
                    darkTeal: 'Albastru-Verde Închis',
                    brown: 'Maro',
                    darkRed: 'Roșu Închis',
                    deepPurple: 'Violet Profund',
                    pureWhite: 'Alb Pur',
                    softWhite: 'Alb Moale',
                    lightGrey: 'Gri Deschis',
                    paleBlue: 'Albastru Pal',
                    paleGreen: 'Verde Pal',
                    paleOrange: 'Portocaliu Pal',
                    lavender: 'Levanță',
                    blueGrey: 'Albastru-Gri'
                }
            },
            systemPrompt: {
                label: 'Instrucțiune Sistem:',
                placeholder: 'Se încarcă instrucțiune sistem...',
                emptyError: 'Instrucțiunea sistem nu poate fi goală!',
                saveSuccess: '✓ Instrucțiune sistem salvată cu succes!',
                loadError: 'Eroare la încărcarea instrucțiunii sistem',
                saveError: 'Eroare la salvare'
            },
            llmProfiles: {
                addButton: '+ Adaugă Nouă Conexiune',
                newConnection: 'Nouă Conexiune',
                editConnection: 'Editează Conexiune',
                emptyState: 'Nu sunt disponibile conexiuni LLM. Apasă mai jos pentru a adăuga una.',
                loadingProfiles: 'Se încarcă profiluri...',
                nameLabel: 'Nume *',
                namePlaceholder: 'de ex. OpenAI GPT-4',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Cheie API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'Toate câmpurile trebuie completate!',
                saveSuccess: '✓ Profil salvat cu succes!',
                deleteConfirm: 'Esti sigur că vrei să ștergi "{name}"?',
                profileNotFound: 'Profil negasit!',
                loadError: 'Eroare la încărcarea profilurilor',
                saveError: 'Eroare la salvare',
                activateError: 'Eroare la activare',
                deleteError: 'Eroare la ștergere',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Adaugă Voce Nouă',
                newVoice: 'Voce Nouă',
                editVoice: 'Editează Voce',
                emptyState: 'Nu sunt disponibile profiluri TTS. Apasă mai jos pentru a adăuga unul.',
                loadingProfiles: 'Se încarcă profiluri TTS...',
                nameLabel: 'Nume',
                namePlaceholder: 'de ex. Adam meu de la ElevenLabs',
                providerLabel: 'Furnizor',
                providerPlaceholder: 'de ex. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Cheie API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Model *',
                modelIdPlaceholder: 'de ex. eleven_monolingual_v1',
                voiceIdLabel: 'ID Voce',
                voiceIdPlaceholder: 'de ex. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Toate câmpurile trebuie completate!',
                saveSuccess: '✓ Profil TTS salvat cu succes!',
                deleteConfirm: 'Esti sigur că vrei să ștergi "{name}"?',
                loadError: 'Eroare la încărcarea profilurilor TTS',
                saveError: 'Eroare la salvare',
                activateError: 'Eroare la activare',
                deleteError: 'Eroare la ștergere'
            },
            language: {
                title: 'Alege Limba',
                description: 'Selectează limba ta preferată pentru interfața utilizator'
            },
        },
        chat: {
            ready: 'Gata',
            start: 'INCEPE',
            stop: 'OPRESTE',
            initialMessage: 'Apasă INCEPE pentru conversație în timp real.',
            listening: 'Ascult...',
            speaking: 'Thorsten vorbește...',
            userLabel: 'Tu',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Scrie un mesaj...',
            send: 'Trimite',
            loginRequired: 'Te rog conectează-te pentru a folosi acest serviciu.',
            loginButton: 'Conectează-te Acum',
            magicLinkRequired: 'Te rog folosesc o legătură magică pentru conectare.',
            creditLimitError: 'Cota ta orară a fost epuizată. Actualizează planul (Medium/Premium) pentru a continua.',
            serviceDisabled: 'Serviciul de chat nu este disponibil momentan. Vă rugăm să încercați din nou mai târziu.'
        },
        notifications: {
            error: 'Eroare',
            success: 'Succes',
            info: 'Informație',
            unknownError: 'A apărut o eroare necunoscută'
        },
        cookie: {
            message: 'Acest site web utilizează cookie-uri pentru a vă oferi cea mai bună experiență de utilizator posibilă.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'Curriculum',
                buttonTitle: 'Afișează conținutul curriculumului',
                modalTitle: 'Curriculum {app}',
                sections: {
                    topic: 'Subiectul curriculumului',
                    explanation: 'Explicație prietenoasă pentru copii',
                    studentProfile: 'Profilul elevului'
                },
                topic: {
                    empty: 'Niciun subiect de curriculum nu este asociat acestei micro-aplicații în backend.',
                    missingDetail: 'Datele detaliate ale curriculumului pentru această micro-aplicație nu sunt încă disponibile în backend.',
                    learningGoals: 'Obiective de învățare',
                    prerequisites: 'Condiții prealabile',
                    unitLabel: 'Unitate',
                    durationLabel: 'Durată',
                    difficultyLabel: 'Dificultate',
                    hours: 'oră',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Nicio explicație prietenoasă pentru copii disponibilă.',
                    loadingPrepare: 'AI pregătește explicația',
                    loadingExplain: 'AI explică subiectul într-un limbaj prietenos pentru copii',
                    requestFailed: 'Explicația prietenoasă pentru copii nu a putut fi generată.'
                },
                studentProfile: {
                    country: 'Țară',
                    region: 'Stat / Regiune',
                    schoolType: 'Tip de școală',
                    grade: 'Clasă',
                    noContext: 'Niciun context al elevului disponibil.',
                    childProfileNotFound: 'Nu s-a găsit niciun profil de elev în backend pentru autentificarea curentă.',
                    loginProfileIncomplete: 'Profilul de autentificare nu conține încă un context complet al elevului.',
                    educationContextNotFound: 'S-a găsit un profil de elev, dar nu este setată nicio atribuire de curriculum.',
                    noToken: 'Nu s-a găsit niciun elev autentificat.'
                },
                errors: {
                    signInRequired: 'Vă rugăm să vă autentificați pentru a vedea curriculumul.',
                    appIdMissing: 'ID-ul aplicației lipsește.',
                    loadFailed: 'Nu s-au putut încărca datele curriculumului.'
                }
            }
    };
